import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  buttonContainer: {
    padding: theme.spacing(3)
  }
})

export default useStyles
